<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
					<!-- home page top address and carousel -->
					<div class="row">					
						<div class="col-md-12">
							<div class="content">
								<store-info></store-info>
							</div>
						</div>
						
						<div class="col-md-12" v-show="store.banners && store.banners.length > 0">
							<carousel :slides="store.banners"/>
						</div>
					</div>
					<div class="row mt-0" >
                        <!-- Hidden menu tab for getting width of avilableMenus-->
                        <div class="col-12 sticky" style="visibility: hidden;margin-top: -50px;z-index: -100;">
							<b-nav pills class="tabs custom-hidden-tab" ref="navigation">
								<b-nav-item 
									v-for="(menu, index) in avilableMenus"
										:key="'menu-' + index">
									{{ menu.title }}
								</b-nav-item>
							</b-nav>
                        </div>
                        <!-- Visible menu tab -->						
						<div class="col-12 sticky" 
							ref="headerMenu"
							id="headerMenu"
							v-resize="onResize">
							<b-nav tabs class="tabs" >
								<b-nav-item 
									v-for="(menu, index) in visibleMenus"
									:key="'menu-' + index"
									:active="is_active_menu_index == index"
									@click="scrollMeTo(index)">
									{{ menu.title }}
								</b-nav-item>
								<b-nav-item v-b-toggle.menu-sidebar
											v-if="hideMenus.length > 0">More<span class="caret"/></b-nav-item>																
							</b-nav>								
						</div>
						
                        <!-- tab content -->
						<div class="col-12" 
							v-for="(menu, index) in avilableMenus" 
							:key="'menu-tab-' + index"
							:ref="'menu-tab-' + index"
							:id="'menu-tab-' + index" >
							<p class="h5 py-2">{{ menu.title }}</p>
							<div class="row"
								:class="{ 'is-active-list-item': is_active_menu_index == index }">
								<div class="col-lg-6 mb-4" v-for="(item, item_index) in menu.items"
									:key="'item-index-' + item_index">
									<div class="menu-card-wrapper with-border">
										<a href="javascript:;"
											class="menu-card image-card"
											@click="set_active_item(item)">
											<div class="menu-card-info">
												<h6 class="menu-card-title text-ellipsis">
													{{ item.title }}
												</h6>
												<div class="description">{{ item.description }}</div>
												<div class="price">{{ (item.price/100) | currency }}</div>
											</div>
											<div class="menu-card-picture" v-if="item.media">
												<b-img-lazy v-if="item.media.squareUrl" :src="item.media.squareUrl" alt="item.title" />
												<b-img-lazy v-else-if="item.media.thumbNail" :src="item.media.thumbNail" alt="item.title" />
											</div>
											<div class="menu-card-picture" v-else-if="item.image">
												<b-img-lazy :src="item.image" alt="item.title" />
											</div>
										</a>
									</div>
								</div>
							</div>								
						</div>
						<div :style="{ height: lastHeight + 'px' }">
						</div>
                    </div>
					<!-- end of row -->
				</div>
				<div class="col-md-4 d-none d-md-block">
					<div class="content" id="width-of-sidebar"></div>
					<!-- my order sidebar -->
					<shopping-cart @editCartItem="edit_cart_item" />
				</div>								
			</div>						
			<b-sidebar  id="menu-sidebar"
						ref="menu-sidebar"
						aria-labelledby="sidebar-no-header-title" 
						no-header shadow right
						backdrop-variant="dark"
					    backdrop
						@shown="onOpenSideBar()"
						@hidden="onCloseSideBar()"						
						class="my-sidebar">				
				<template v-slot:default="{ hide }">
					<div class="p-3">
						<nav class="mb-5">
							<b-nav vertical pills>
								<b-nav-item 
									v-for="(menu1, index1) in hideMenus"
									:key="index1"
									:active="is_active_menu_index == cutIndex + index1"
									@click="scrollMeTo(cutIndex + index1);">{{ menu1.title }}</b-nav-item>
							</b-nav>
						<b-button variant="primary" block @click="hide">Close</b-button>
						</nav>	
					</div>
				</template>
			</b-sidebar>	
			<!-- end of main row -------------- -->
		</div>
<!-- https://mdbootstrap.com/docs/jquery/utilities/display/ -->
<!-- https://stackoverflow.com/questions/45666656/bootstrap-4-responsive-utilities-visible-hidden-xs-sm-lg-not-working -->
		<!-- modal window -->		
		<product-modal 
			v-if="isShowProduct"
			:data_item="modal_item"
			:cart-item-index="modal_cart_item_index"		
			@close="closeModal"	/>
		<div v-bind:style="{height:footer_height+'px'}" />		
		<footer
				ref="footer"
				color="blue"
				class="footer fixed-bottom footer-light footer-shadow d-block d-md-none">
			<router-link
						v-if="cartTotal.qty > 0" 
						to="/shopping-cart-page" 
						class="btn btn-primary btn-block view-order">
				<div class="d-flex justify-content-between align-items-center">
					<div>
						<i class="fas fa-shopping-cart"></i> Checkout ({{cartTotal.qty}})
					</div>
					<div>{{total_price() / 100.0 | currency}}</div>
				</div>
			</router-link>
		</footer>
	</div>
</template>

<script>
	import ProductModal from "@/components/menu/ProductModal.vue";
	import ShoppingCart from "@/components/menu/ShoppingCart.vue";

//	import Swal from 'sweetalert2';
	import Carousel from '@/components/menu/Carousel'
	import StoreInfo from '@/components/menu/StoreInfo'
	import resize from 'vue-resize-directive'
	import moment from 'moment'

	import {mapState} from 'vuex'

	export default {
		props: {
		},
		components: {
			ProductModal,
			ShoppingCart,
			Carousel,
			StoreInfo			
		},
		directives: {
			resize,
		},
		data() {
			return {
				footer_height:0,
				is_active_menu_index: 0,
				modal_item: null,
				modal_cart_item_index: null,
				isShowProduct: false,
				cutIndex: 0,
				lastHeight:0,
				headerMenuHeight:0
			};
		},
		watch:{
			is_active_menu_index(){
			},
			isShowProduct(){
				 if(!this.isShowProduct && window.location.hash === "#/ProductModal"){					
				 	history.back()
				 }
			},
			menus:{
				deep:true,
				handler(){
					setTimeout(()=>{
						this.onResize()						
					},100)
				}
			},
			'$route': {
				 immediate: true,
				 deep: true, 
				 handler(newValue, oldValue) {
					console.log("Route", newValue, oldValue)
				}
			},
			cartTotal:{
				deep:true,
				handler(){
					this.setFooterHeight()
				}
			}						
		},
		computed: {
			...mapState({
				store: 'store',
				menus: 'menus'
			}),
			cartTotal() {
            	return this.$store.getters.cartTotal;
	        },
			avilableMenus(){
				var previousDay = moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'days')
				let today = moment()

				return this.menus.filter(menu  => {
					var filterdItems =  menu.items.filter(item => 
					  	{	
							var avilable = item.alwaysAvailable						
							if(!avilable){
							let previousHours = item.hours[previousDay.format('dddd').toLowerCase()]   								
								previousHours.forEach((hour) => {
									let sT = moment(hour.startTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')			
									let eT = moment(hour.endTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')	
									
									if(!sT.isBefore(eT)){// true means this is in same day even et is in current day
										eT.add(1, 'days')					
										if(moment().isBefore(eT)){
											avilable = true
											console.log("AddedByLastDay", sT.format() , eT.format())
											return
										}
									}				
								})
							}	

							if(!avilable){
							var hours = item.hours[today.format('dddd').toLowerCase()]								
								if(hours.length === 0){
									avilable = false
								}	
								hours.forEach((hour) => {
									let sT = moment(hour.startTime, ['h:ma', 'H:m']).set({second:0, millisecond:0})		
									let eT = moment(hour.endTime, ['h:ma', 'H:m']).set({second:0, millisecond:0})
									if(!sT.isBefore(eT)){// true means this is in same day even it is in current day
										eT.add(1, 'days')										
									}	
									avilable = sT.isBefore(moment()) && moment().isBefore(eT)
									if(avilable){
										console.log("AddedByToDay", sT.format() , eT.format())
										return
									}																
								})															
							}			
							return avilable
						})
					menu.items = filterdItems
					return menu.items.length > 0
				})
			},
			visibleMenus() {
				return this.avilableMenus.slice(0, this.cutIndex)
			},
			hideMenus() {				
				return this.avilableMenus.slice(this.cutIndex)
			}
		},
		mounted(){
			 this.$nextTick(() => {						
				// Code that will run only after the
				// entire view has been rendered 				
			})
		},
		created: function () {
	        this.$store.dispatch('lsOSinOrdering')
			window.addEventListener('hashchange', this.hash_change)
		},
		destroyed: function () {
			window.removeEventListener('hashchange', this.hash_change)
		},		
		methods: {
			hash_change(hash){
				let oldURL = new URL(hash.oldURL)
				let newURL = new URL(hash.newURL)
				if(newURL.hash === "#/" && oldURL.hash === "#/ProductModal"){
					this.closeModal()
				}
				if(newURL.hash === "#/" && oldURL.hash === "#/MenuSideBar"){
					this.$refs['menu-sidebar'].localShow = false
				}
			},
			/**
			* set modal window data
			*/
			set_active_item(item) 
			{
				this.modal_item = item;
				this.modal_cart_item_index = null
				this.isShowProduct = true
			},

			edit_cart_item(index)
			{
				var cartItem = this.$store.getters.cartItems.find( (item,i) => i == index )
				this.modal_item = cartItem.item;
				this.modal_cart_item_index = index;
				this.isShowProduct = true
			},
		
			closeModal() {
				this.isShowProduct = false
			},
			closeDropdown() {
				this.$refs.dropdown.hide(true)
			},
			onCloseSideBar() {
				if(window.location.hash === "#/MenuSideBar"){
				 	history.back()
				}	
				document.getElementsByTagName("body")[0].style.overflow = "auto";			
			},
			onOpenSideBar() {
				history.pushState(null, null, '#/MenuSideBar');
				document.getElementsByTagName("body")[0].style.overflow = "hidden";
				document.getElementById("menu-sidebar").style.position = "auto";	
			},
			scrollMeTo(index) {
				this.is_active_menu_index = index
				{
					let refName = 'menu-tab-' + (this.avilableMenus.length - 1);
					let lastSectionsContentHeight = document.getElementById(refName) === null ?0:document.getElementById(refName).offsetHeight;
					this.headerMenuHeight = document.getElementById('headerMenu') === null?0:document.getElementById('headerMenu').offsetHeight;
					this.lastHeight = Math.max(0, window.innerHeight - lastSectionsContentHeight - this.headerMenuHeight);
//					console.log(refName, lastSectionsContentHeight, this.headerMenuHeight, this.lastHeight)
				}
				
				let refName = 'menu-tab-' + index
				var top = document.getElementById(refName).offsetTop;
	
				if(this.$refs['menu-sidebar'].isOpen){
					this.$refs['menu-sidebar'].localShow = false
					setTimeout(()=>{
						window.scrollTo(0, top);
					},1000)					
				} else {
					window.scrollTo(0, top);					
				}								
			  },
			total_price() {
				let taxRate1 = this.$store.getters.getState.tax
				let taxRate2 = this.$store.getters.getState.tax2
			
				let tipPrice = 0//this.$store.getters.tipAmount
				return this.cartTotal.sum  + tipPrice + (this.cartTotal.sum && taxRate1 
                 ? (this.cartTotal.sum * taxRate1) / 100.0 : 0) + (this.cartTotal.sum && taxRate2 
                 ? (this.cartTotal.sum * taxRate2) / 100.0 : 0)
			},
			onResize() {
				let _ele = this.$refs['navigation']
				if(_ele){
					let navWidth = _ele.clientWidth
					let MORE_WIDTH = 84			
					var total = MORE_WIDTH// depend on more button text 
					var childIndex = 0
					_ele.children.forEach(child => {
						if(total >= navWidth){
							return
						}
						total += child.clientWidth
						if(total >= navWidth){
							return
						}
						childIndex++
					});
					this.cutIndex = childIndex
					this.setFooterHeight()
				}
			},
			setFooterHeight() {
				this.footer_height = this.$refs['footer'] === undefined ? 0 : this.$refs['footer'].offsetHeight	 
			}
						
		}
	};
</script>

<style scoped lang="scss">
	.sidebar-sticky {
		position: sticky;
		top: 0;
		right: 0;
	}
	:target:before {
		content: "";
		display: block;
		height: 90px;
		margin: -90px 0 0;
	}
	.custom-hidden-tab{
		align-items: center;
    	flex-wrap: unset;
    	display: -webkit-box;
    	overflow: hidden;
	}
	.dropdown-menu{
    	display: unset;
		left: unset;
	    right: 0;
	}
	.is-active-list-item {
		border: 1px solid;
		padding: 5px;
		border-radius: 4px;
	}
	.special-more-active{
		color: #495057 !important;
	    background-color: #fff;
   		 border-color: #dee2e6 #dee2e6 #fff;
	}

	.special-popup-height{
		height: 300px;
		overflow-y: scroll;
		overscroll-behavior: auto;
	}
	
	.fix-height >>> .dropdown-menu {
		max-height: 200px;
		overflow-y: auto;
	}

	.b-sidebar-outer{
		-webkit-overflow-scrolling: touch;
	}

	.view-order{
    	border-radius: 5px 5px 0px 0px;
	}
	
</style>